<template>
  <div>
    <div class="row mb-5">
      <div class="col-12" style="display: flex; align-items: center">
        <span class="display-4">
          {{ `${establishment.company_name}` }} - {{ $t("COMMON.INTERNAL_INVOICES") }}
        </span>
        <base-button
          v-if="establishment.active"
          type="primary"
          icon
          size="sm"
          @click="
            () => {
              showAddInternalInvoiceModal = true;
            }
          "
        >
          <span class="btn-inner--icon">
            <i class="ni ni-single-copy-04"></i>
            {{ $t("COMMON.ADD") }}
          </span>
        </base-button>
        <help-button context="internal-invoices" class="ml-2" />
      </div>
    </div>

    <establishment-internal-invoice-list-table
      ref="internalInvoiceTable"
      :filterEstablishment="establishment.id"
      :hideAddButton="true"
    />

    <establishment-view-internal-invoices-add-internal-invoice-modal
      :establishment="establishment"
      :showModal="showAddInternalInvoiceModal"
      @onCloseModal="showAddInternalInvoiceModal = false"
      @created="refreshInternalInvoices"
    />
  </div>
</template>

<script>
import EstablishmentInternalInvoiceListTable from "@/views/Pages/InventoryModule/EstablishmentInternalInvoiceManagement/partials/EstablishmentInternalInvoiceListTable.vue";
import EstablishmentViewInternalInvoicesAddInternalInvoiceModal from "./EstablishmentViewInternalInvoicesAddInternalInvoiceModal.vue";

export default {
  name: "EstablishmentViewInternalInvoices",
  components: {
    EstablishmentInternalInvoiceListTable,
    EstablishmentViewInternalInvoicesAddInternalInvoiceModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAddInternalInvoiceModal: false,
    };
  },
  methods: {
    refreshInternalInvoices() {
      this.$refs.internalInvoiceTable?.getList();
    },
  },
};
</script>
